import { makeStyles } from '@fluentui/react-components';
import { isMobile } from 'react-device-detect';

import { customTokens } from 'src/utils/theme';

export const dailyHabitsTodayStatusStyles = makeStyles({
  contentContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
  contentWrapper: {
    display: 'flex',
    columnGap: isMobile ? customTokens.spacingHorizontalL : customTokens.spacingHorizontal4XL,
  },
  missedCircle: {
    width: isMobile ? '72px' : '88px',
    fontSize: customTokens.fontSizeBase500,
  },
  todayCircle: {
    width: isMobile ? '92px' : '108px',
    fontSize: customTokens.fontSizeBase600,
  },
  upcomingCircle: {
    width: isMobile ? '72px' : '88px',
    fontSize: customTokens.fontSizeBase500,
  },
});
